
// SVG Icon: compass-inner
export default { id: "terriajs-compass-inner" };
export const id = "terriajs-compass-inner";
export const name = "compass-inner";
